import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import css from './TruncatedNote.css';

const TruncatedNote = ({ count, translationId }) => {
    if (!(count > 0)) {
        return null;
    }
    return (
        <div className={css.truncated}>
            <Translate id={translationId} data={{ count }} />
        </div>
    );
};

TruncatedNote.propTypes = {
    count: PropTypes.number,
    translationId: PropTypes.string.isRequired,
};

export default TruncatedNote;
